import { Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface DateQuickButtonsProps {
  currentValue?: string;
  onChange: (newDate: string | undefined) => void;
  isDisabled?: boolean;
}

export const DateQuickButtons = ({ currentValue, onChange, isDisabled }: DateQuickButtonsProps) => {
  const { t } = useTranslation(['v0/tasks', 'v0/common', 'common']);

  return (
    <Flex mt={2} gap={2}>
      <Button
        size="sm"
        variant="outline"
        borderRadius="md"
        bg={useColorModeValue('gray.50', 'gray.700')}
        _hover={{ bg: useColorModeValue('gray.100', 'gray.600') }}
        onClick={() => {
          const today = new Date();
          today.setHours(23, 59, 0, 0);
          onChange(today.toISOString());
        }}
        isDisabled={isDisabled}
      >
        <Flex align="center" justify="center">
          <Text fontSize="sm" mr={1}>{t('common:icons.sun')}</Text>
          <Text fontSize="sm">{t('v0/tasks:form.dates.today')}</Text>
        </Flex>
      </Button>
      <Button
        size="sm"
        variant="outline"
        borderRadius="md"
        bg={useColorModeValue('gray.50', 'gray.700')}
        _hover={{ bg: useColorModeValue('gray.100', 'gray.600') }}
        onClick={() => {
          const baseDate = currentValue ? parseISO(currentValue) : new Date();
          baseDate.setDate(baseDate.getDate() + 1);
          baseDate.setHours(23, 59, 0, 0);
          onChange(baseDate.toISOString());
        }}
        isDisabled={isDisabled}
      >
        <Text fontSize="sm">{t('v0/tasks:form.dates.tomorrow')}</Text>
      </Button>
      <Button
        size="sm"
        variant="outline"
        borderRadius="md"
        bg={useColorModeValue('gray.50', 'gray.700')}
        _hover={{ bg: useColorModeValue('gray.100', 'gray.600') }}
        onClick={() => {
          const baseDate = currentValue ? parseISO(currentValue) : new Date();
          baseDate.setDate(baseDate.getDate() + 7);
          baseDate.setHours(23, 59, 0, 0);
          onChange(baseDate.toISOString());
        }}
        isDisabled={isDisabled}
      >
        <Text fontSize="sm">{t('v0/tasks:form.dates.nextWeek')}</Text>
      </Button>
      <Button
        size="sm"
        variant="outline"
        borderRadius="md"
        bg={useColorModeValue('gray.50', 'gray.700')}
        _hover={{ bg: useColorModeValue('gray.100', 'gray.600') }}
        onClick={() => {
          const baseDate = currentValue ? parseISO(currentValue) : new Date();
          baseDate.setMonth(baseDate.getMonth() + 1);
          baseDate.setHours(23, 59, 0, 0);
          onChange(baseDate.toISOString());
        }}
        isDisabled={isDisabled}
      >
        <Text fontSize="sm">{t('v0/tasks:form.dates.nextMonth')}</Text>
      </Button>
      <Button
        size="sm"
        variant="outline"
        borderRadius="md"
        bg={useColorModeValue('gray.50', 'gray.700')}
        _hover={{ bg: useColorModeValue('gray.100', 'gray.600') }}
        colorScheme="gray"
        onClick={() => onChange(undefined)}
        isDisabled={isDisabled}
      >
        <Text fontSize="sm">{t('common:actions.clear')}</Text>
      </Button>
    </Flex>
  );
};